<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-drawer`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M42 44a2 2 0 002-2V23L36.346 5.448C36.076 4.584 35.31 4 34.446 4H13.202c-.863 0-1.628.584-1.899 1.448L4 23v19a2 2 0 002 2h36zM33.166 8.228H14.813L8 23h12v8.4h8V23h12L33.166 8.228zM8 27.2h8v7.4a1 1 0 001 1h14a1 1 0 001-1v-7.4h8v12.6H8V27.2z"/></svg>
</template>
<script>

export default {
  name: 'IconDrawer',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
